import Link from 'next/link';

import { authorPageUrl } from 'src/services/route-utils';
import AuthorImage from './AuthorImage';

type Props = {
    author: any;
};

export default function AuthorCard({ author }: Props) {
    return (
        <div className="group">
            <div className="relative h-60">
                <Link className="block h-full overflow-hidden" href={authorPageUrl(author)}>
                    <AuthorImage author={author} />
                </Link>
            </div>
            <div className="z-10 p-4">
                <Link href={authorPageUrl(author)} className="decoration-1 underline-offset-4 group-hover:underline">
                    <h3 className="mb-4 line-clamp-2 text-lg">{author.name}</h3>
                </Link>
                <p className="text-sm">{author.title}</p>
            </div>
        </div>
    );
}
